import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import Icon from '../../icon';
import RoutableNotEditableLink from '../../routableNotEditableLink';
import { TRegularLink } from '../types/socialMediaBar.types';
import { googleSocialEvent } from '../../../../utils/analytics';

const RegularLink: FC<TRegularLink> = (props) => {
  const { item, socialMediaButtonName, useAnalytics } = props;

  return (
    <RoutableNotEditableLink
      href={''}
      className={`social-media-bar__social-icon-link a2a_button_${socialMediaButtonName}`}
      target="_blank"
      data-title={item.fields?.postText?.value}
      data-usefallback-window-title={true}
      data-is-page-url={true}
      onClick={() => useAnalytics && googleSocialEvent(item.fields.socialMedia.displayName)}
    >
      <Icon iconField={item?.fields?.icon} size={iconSize.mbl} color={'primary'} />
    </RoutableNotEditableLink>
  );
};

export default RegularLink;
